import React from 'react';
import t from 'prop-types';
import Boton from './boton';

var BotonImagen = function BotonImagen(_ref) {
  var clases = _ref.clases,
      children = _ref.children,
      desactivado = _ref.desactivado,
      onClick = _ref.onClick;
  return React.createElement(Boton, {
    clases: '' + clases,
    desactivado: desactivado,
    onClick: onClick
  }, children);
};

BotonImagen.propTypes = process.env.NODE_ENV !== "production" ? {
  clases: t.string,
  desactivado: t.bool,
  onClick: t.func,
  children: t.node
} : {};
BotonImagen.defaultProps = {
  desactivado: false,
  texto: '',
  clases: ''
};
export default BotonImagen;